import { Box, Button, Flex, Grid, Label, Text } from "atoms";
import React, { useEffect, useState } from "react";
import MemoClose from "assets/icons/Close";
import { Formik, Form } from "formik";
import { FormRadio, FormSelect } from "molecules/FormInput";
import { optionFetch } from "utils/utilities";
import { useLocationQueryAdd } from "hooks/useLocationQuery";
import { useSearchParams } from "react-router-dom";
import { usePropsoch } from "contexts/Propsoch";
import { PROPERTY_PUBLISH_STATUS } from "utils/constants";

// const validationSchema = Yup.object().shape({
//   firstname: Yup.string().max(60, "Maximum 60 characters").required("Required"),
//   lastname: Yup.string().max(60, "Maximum 60 characters"),
// });

export const Filter = ({ onClose, locations, micromarkets }) => {
  const {
    state: { userRole },
  } = usePropsoch();
  const [searchParams] = useSearchParams();
  const setParam = useLocationQueryAdd();

  const locationFilter = searchParams.get("location");
  const isPublishedFilter = searchParams.get("isPublished");
  const micromarketFilter = searchParams.get("micromarket");
  const draftedFilter = searchParams.get("drafted");
  const revertedFilter = searchParams.get("reverted");
  const statusFilter = searchParams.get("status");
  const projectTypeFilter = searchParams.get("projectType");

  // status, type & typology fetch

  const [type, setType] = useState([]);

  useEffect(() => {
    // type
    optionFetch("/propertytypes/get", "name", "id").then((data) => {
      setType(data);
    });
  }, []);

  const onSubmit = ({
    location,
    micromarket,
    isPublished,
    drafted,
    reverted,
    status,
    projectType,
  }) => {
    setParam("page", undefined);
    setParam("search", undefined);
    setParam("location", location);
    setParam("micromarket", micromarket);
    setParam("isPublished", isPublished.toString());
    setParam("drafted", drafted.toString());
    setParam("reverted", reverted.toString());
    setParam("status", status.toString());
    setParam("projectType", projectType.toString());
    onClose();
  };

  return (
    <Box
      width="48rem"
      p="3.2rem"
      bg="white"
      borderRadius="1rem"
      boxShadow="4px 4px 40px rgba(0, 0, 0, 0.06)"
    >
      <Flex
        mb="2.4rem"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="neutral.100"
        pb="2.4rem"
      >
        <Text fontSize="2rem" color="primary.900" fontFamily="NeometricBold">
          Filter
        </Text>
        <MemoClose
          height="1.5rem"
          width="1.5rem"
          onClick={onClose}
          style={{ cursor: "pointer" }}
        />
      </Flex>
      <Formik
        initialValues={{
          location: parseInt(locationFilter) || "",
          micromarket: parseInt(micromarketFilter) || "",
          isPublished: isPublishedFilter || "",
          drafted: draftedFilter || "",
          reverted: revertedFilter || "",
          status: statusFilter || "",
          projectType: projectTypeFilter || "",
        }}
        onSubmit={onSubmit}
        // validationSchema={validationSchema}
      >
        {({ values, setFieldValue }) => {
          return (
            <Form>
              <Grid gRG="2rem">
                <Grid
                  // gridAutoFlow="column"
                  gridTemplateColumns="1fr 1fr"
                  gridGap="1rem"
                >
                  <Box>
                    <Label text="Market" mb="1rem" />
                    <FormSelect name="location" options={locations} />
                  </Box>
                  <Box>
                    <Label text="Micromarket" mb="1rem" />
                    <FormSelect
                      name="micromarket"
                      options={micromarkets?.filter(
                        (i) => i?.data?.locationId === values?.location
                      )}
                    />
                  </Box>
                </Grid>
                <Label text="Project Type" />
                <Grid
                  gridTemplateColumns="1fr 1fr 1fr"
                  gridGap="1rem"
                  justifyItems="center"
                >
                  {type?.map((item, index) => {
                    return (
                      <Flex aI="center" key={index}>
                        <FormRadio
                          name="projectType"
                          label={item?.label}
                          value={item?.value?.toString()}
                        />
                      </Flex>
                    );
                  })}
                </Grid>
                <Label text="Category" />
                <Grid
                  // gridAutoFlow="column"
                  gridTemplateColumns="1fr 1fr"
                  gridGap="1rem"
                >
                  {(userRole?.isAdmin || userRole?.isSuperadmin) && (
                    <Flex aI="center">
                      <FormRadio
                        name="isPublished"
                        label={"Published"}
                        value={"true"}
                        onClick={() => {
                          setFieldValue("reverted", "");
                          setFieldValue("drafted", "");
                          setFieldValue("status", "");
                        }}
                      />
                    </Flex>
                  )}

                  {(userRole?.isAdmin ||
                    userRole?.isSuperadmin ||
                    userRole?.isChecker) && (
                    <Flex aI="center">
                      <FormRadio
                        name="isPublished"
                        label={"Unpublished"}
                        value={"false"}
                        onClick={() => {
                          setFieldValue("reverted", "");
                          setFieldValue("drafted", "");
                          setFieldValue("status", "");
                        }}
                      />
                    </Flex>
                  )}

                  {(userRole?.isAdmin ||
                    userRole?.isSuperadmin ||
                    userRole?.isChecker) && (
                    <Flex aI="center">
                      <FormRadio
                        name="drafted"
                        label={"Drafted"}
                        value={"true"}
                        onClick={() => {
                          setFieldValue("status", "");
                          setFieldValue("reverted", "");
                          setFieldValue("isPublished", "");
                        }}
                      />
                    </Flex>
                  )}
                  {(userRole?.isAdmin ||
                    userRole?.isSuperadmin ||
                    userRole?.isMaker) && (
                    <Flex aI="center">
                      <FormRadio
                        name="reverted"
                        label={"Reverted"}
                        value={"true"}
                        onClick={() => {
                          setFieldValue("drafted", "");
                          setFieldValue("status", "");
                          setFieldValue("isPublished", "");
                        }}
                      />
                    </Flex>
                  )}

                  {(userRole?.isAdmin ||
                    userRole?.isSuperadmin ||
                    userRole?.isMaker) && (
                    <Flex aI="center">
                      <FormRadio
                        name="status"
                        label={"Completed"}
                        value={PROPERTY_PUBLISH_STATUS.completed}
                        onClick={() => {
                          setFieldValue("reverted", "");
                          setFieldValue("drafted", "");
                          setFieldValue("isPublished", "");
                        }}
                      />
                    </Flex>
                  )}
                  {(userRole?.isAdmin ||
                    userRole?.isSuperadmin ||
                    userRole?.isMaker) && (
                    <Flex aI="center">
                      <FormRadio
                        name="status"
                        label={"In Progress"}
                        value={PROPERTY_PUBLISH_STATUS.progress}
                        onClick={() => {
                          setFieldValue("reverted", "");
                          setFieldValue("drafted", "");
                          setFieldValue("isPublished", "");
                        }}
                      />
                    </Flex>
                  )}
                </Grid>

                <Button
                  type="submit"
                  variant="primary"
                  height={{ xs: "4.3rem", lg: "4.8rem" }}
                  mt="1rem"
                >
                  Filter
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};
